<template>
    <InfoModal
        :info="info"
        :illustrationPath="illustrationPath"
    />
</template>

<script>
    import InfoModal from '@app/modals/modals/InfoModal';

    export default {
        name: 'SmsLimitReached',
        data() {
            return {
                /* eslint-disable-next-line max-len */
                info: 'You have sent the maximum number of SMS messages. If you wish to send more, please contact support',
                illustrationPath: '/static/img/illustrations/ticket__check-error.svg',
            };
        },
        components: {
            InfoModal
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/SmsLimitReachedModal.vue